// Safari with "Block all cookies" enabled (and some sandboxed iframe contexts)
// throws `ReferenceError: Can't find variable: localStorage` (and the same for
// sessionStorage) on bare access — the API itself is not defined, not just
// empty. The `typeof window` guard alone doesn't cover this; only a try/catch
// around the actual call does.
// See PostHog issue 019da5a9-898d-71e2-aa47-9b20dafeb65d (localStorage variant).
//
// For React state synced to localStorage, prefer the `useLocalStorage` hook
// in `hooks/use-local-storage.ts` — it has the same hardening plus
// useSyncExternalStore semantics for hydration safety. These primitives are
// for non-React or imperative callsites (auth, error recovery, consent banner).

export function safeGetItem(key: string): string | null {
  try {
    if (typeof window === 'undefined') return null
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeSetItem(key: string, value: string): boolean {
  try {
    if (typeof window === 'undefined') return false
    window.localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export function safeRemoveItem(key: string): boolean {
  try {
    if (typeof window === 'undefined') return false
    window.localStorage.removeItem(key)
    return true
  } catch {
    return false
  }
}

export function safeGetSessionItem(key: string): string | null {
  try {
    if (typeof window === 'undefined') return null
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeSetSessionItem(key: string, value: string): boolean {
  try {
    if (typeof window === 'undefined') return false
    window.sessionStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export function safeRemoveSessionItem(key: string): boolean {
  try {
    if (typeof window === 'undefined') return false
    window.sessionStorage.removeItem(key)
    return true
  } catch {
    return false
  }
}
